import React from "react";
import InputComponentV2 from "../../InputComponentV2";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";
import DropDownAllStaffsV2Mobile from "../../Dropdowns/DropDownAllStaffsV2Mobile";
import DropDownSpecificStaffV2Mobile from "../../Dropdowns/DropDownSpecificStaffV2Mobile";

function GeneralInformationV2TreatmentSection(props) {
  const {
    translate,
    clientStatus,
    handleClientStatusChange,
    roomNumber,
    handleRoomNumberChange,
    selectedTherapist,
    handleSelectedTherapistChange,
    assignedSupportWorker,
    handleAssignedSupportWorkerChange,
  } = props;

  return (
    <div style={{ padding: "0px", width: "100%", paddingBottom: "20px" }}>
      <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px" }}>
        <span id="treatment-information" style={{ fontSize: "14px", fontWeight: "600", paddingLeft: "10px" }}>{translate("TreatmentInformation")}</span>
      </div>
      <div style={{ width: "100%", paddingLeft: "10px", paddingTop: "15px", paddingBottom: "10px", display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: "wrap" }}>
        <DropDownComponentSortedV2 api="clientStatus" title={translate("ClientStatus")} value={clientStatus} onChange={handleClientStatusChange} width="100%" />
        <InputComponentV2 title={translate("RoomNumber")} width="100%" value={roomNumber} onChange={handleRoomNumberChange} />
        <DropDownAllStaffsV2Mobile title={translate("AssignedTherapist")} value={selectedTherapist} width="auto" onChange={handleSelectedTherapistChange} />
        <DropDownSpecificStaffV2Mobile title={translate("AssignedSupportStaff")} value={assignedSupportWorker} onChange={handleAssignedSupportWorkerChange} allowedRoles={["Support Staff"]} width="250px" />
      </div>
    </div>
  );
}

export default GeneralInformationV2TreatmentSection;
